import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import LinkedinIcon from '@mui/icons-material/LinkedIn';

import { FacebookShareButton, TwitterShareButton, WhatsappShareButton, LinkedinShareButton } from 'react-share';

const StyledMenu: any = styled((props) => (
    <Menu
        elevation={0}
        open={false}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            },
        },
    },
}));

export default function ReUsableShareSheet({
    open,
    anchorEl,
    handleClose,
    url,
}: {
    open: Boolean;
    anchorEl: any;
    handleClose: any;
    url: string;
}) {
    const handleCopyLink = () => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(url);
            setTimeout(handleClose());
        }
    };

    return (
        <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
                'aria-labelledby': 'demo-customized-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            <MenuItem disableRipple>
                <FacebookShareButton url={url} className="flex grow" onClick={handleClose}>
                    <FacebookIcon />
                    Facebook
                </FacebookShareButton>
            </MenuItem>
            <MenuItem disableRipple>
                <TwitterShareButton url={url} className="flex grow" onClick={handleClose}>
                    <TwitterIcon />
                    Twitter
                </TwitterShareButton>
            </MenuItem>
            <MenuItem disableRipple>
                <WhatsappShareButton url={url} className="flex grow" onClick={handleClose}>
                    <WhatsAppIcon />
                    WhatsApp
                </WhatsappShareButton>
            </MenuItem>
            <MenuItem disableRipple>
                <LinkedinShareButton url={url} className="flex grow" onClick={handleClose}>
                    <LinkedinIcon />
                    Linkedin
                </LinkedinShareButton>
            </MenuItem>

            <Divider sx={{ my: 0.5 }} />
            <MenuItem disableRipple onClick={handleCopyLink}>
                <InsertLinkIcon />
                Copy Link
            </MenuItem>
        </StyledMenu>
    );
}
